// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2zrYD","list":"styles_list__1x2Vk"};